import React from 'react';

import { selectIsTenant, useDomainStore } from '@/store/use-domain.store';
import { isDesktop } from 'react-device-detect';

import { type VendorItemResponse } from '@/common/apis/storefronts/v1/get-vendor.api';
import DiscountBadge from '@/common/components/discount-badge';
import Price from '@/common/components/price/price.component';
import { appConfigs } from '@/common/configs/app.config';

import StoreInfo from './storeInfo.component';

interface Props {
  title: string;
  categeory: string;
  price: number;
  discount: number;

  vendor?: VendorItemResponse;
}

const Description = ({
  vendor,
  categeory,
  price = 0,
  title,
  discount,
}: Props) => {
  const isTenant = useDomainStore(selectIsTenant);
  if (isDesktop) {
    return (
      <div className="mt-2.5 flex h-fit flex-col items-start justify-between">
        {!isTenant && <StoreInfo item={vendor} />}
        <div className="mb-5 flex h-fit w-full flex-row items-center justify-between">
          <h2 className="mb-1 line-clamp-2 flex-1 text-ellipsis text-sm font-semibold text-black-default lg:!text-lg">
            {title}
          </h2>
          {Boolean(discount) && (
            <DiscountBadge percent={discount} text="تخفیف" />
          )}
        </div>

        <div className="flex w-full items-start justify-between">
          <span className="rounded-md bg-silver-200 p-1.5 text-xs font-medium text-black-default">
            {categeory}
          </span>
          <Price
            className="!items-start !gap-x-2"
            priceWrapperClassName="flex-col !items-end"
            priceClassName="text-black-default font-semibold !text-sm"
            discountClassName="!text-sm text-secondary-300 font-normal"
            price={price}
            alignment="vertical"
            discount={discount || undefined}
          />
        </div>
      </div>
    );
  } else {
    return (
      <div className="flex w-full flex-col">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="line-clamp-2 text-ellipsis text-sm font-semibold text-black-default">
              {title}
            </h2>
          </div>
          <div className="flex shrink-0 items-center gap-2">
            {Boolean(discount) && (
              <DiscountBadge percent={discount} text="تخفیف" />
            )}
            <span className="text-base font-semibold text-black-default">
              {Number(price * ((100 - discount) / 100)).toLocaleString()}
            </span>
          </div>
        </div>
        <div className="flex items-center justify-between">
          <div>
            <h2 className="line-clamp-1 text-ellipsis text-xs font-medium text-secondary-300">
              {categeory}
            </h2>
          </div>
          <div>
            {discount ? (
              <span className="text-xs font-normal text-secondary-300 line-through">
                {price.toLocaleString()}
              </span>
            ) : (
              <></>
            )}
            <span className="text-xs font-normal text-secondary-300">
              {appConfigs.currency}
            </span>
          </div>
        </div>
      </div>
    );
  }
};

export default Description;
